import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/ipr_logo.png")